# frozen_string_literal: true

module Engine
  module Game
    module G1822Africa
    end
  end
end
